import { render, staticRenderFns } from "./drawBigger.vue?vue&type=template&id=438f8916&scoped=true&"
import script from "./drawBigger.vue?vue&type=script&lang=js&"
export * from "./drawBigger.vue?vue&type=script&lang=js&"
import style0 from "./drawBigger.vue?vue&type=style&index=0&id=438f8916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438f8916",
  null
  
)

component.options.__file = "drawBigger.vue"
export default component.exports